GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.fsCount = 0;
  this.respinsAdded = 0;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;
  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;
  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inBuyABonus = false;
  this._inLuckyBet = false;
  this._localRngSeed = -1;
  this._uiRandomSeed = -1;
  this._trailPosition = 0;
  this._trailLevel = 1;
  this._trailPositionIncreased = false;

  this.freeSpinsCostMaxMultiplier;
  this.freeSpinsCostMultiplier;
  this.luckyBetCostMultiplier;

  this._totalWinnings = 0;
  this._numLines = 10;

  this._persistentValues = {};

  //Game specific data
  this.awardPayLinesBeforeCollectables;
  this.hasPaylines;
  this.spinToCollectables;
  this.nudgeModifier;
  this.boostModifier;
  this.multiModifier;
  this.respinModifier;
  this.collectableAwards;
  this.treasureChestAdd;
  this.treasureChestClose;
  this.devilProgress;
  this.canFirewave = false;
  this.firstFreeSpin = false;
  this.finalFreeSpin = false;

  //Free Spins
  this.baseGameChestClose;
  this.bonusBuyChestColour;
  this.devilLevel;
  this.isBonusBuy;
  this.fsSpinWinnings;
  this.totalFsWinnings = 0;
  this.treasureChestClose;

  // this.loadLanguageFiles = undefined; // delete me when translations are ready

  this.buyBonusLowActive = false;
  this.buyBonusMedActive = false;
  this.buyBonusHighActive = false;
  this.prepaidInitialBalance = 0;
  this.prepaidResultBalance = 0;
};
GatiServer.prototype.clientReadyToStart = function (cbWhenPlatformReady) {
  var self = this;
  const informGameReady = async (slot) => {
    var readyResponse = await slot.getGameEventsEmitter().gameReady({ defaultBetValue: this._stake / 100 });
    console.log("Gati Platform: Restore Mode set to " + readyResponse.restoreMode);
    // no longer modal
    messageBus.post("game:modal", {});
    self._finishedLoading = true;
    self._isRecoveryGame = readyResponse.restoreMode === "RESTORE";
    if (self._inRewatchMode || self._inReplayMode || self._isRecoveryGame) {
      gdk.startMinGameTimer(); // we bypass start during recovery so the gdk wont do this for us
      self._isPrePaidGame = true; // Tells setBPL not to show max stake popup, this is a recover game they have already seen this popup
      let stakeInfo = self.restorePreviousWagers();
      self._isPrePaidGame = slot.getWagerHelper().getPrepaidInfo().isPrepaid; //prepaids has a very specifice purpose and this isnt it, so put it back!
      self.initNewGame({ stake: stakeInfo.stake, bpl: stakeInfo.baseStake / self._numLines }, self._isRecoveryGame);

      // now initGame no longer sends balance out because PokerStars doesnt want to the debit until
      // a result has been received so there are no errors, we must do it explicitly in side rewatch/recover/replay
      self.addBalanceEventToQueue();
      self.triggerNextMessage();

      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      self._wagerId = self._latestEngineReponse.wager.wagerid;
      await this._slotGame.getGameEventsEmitter().gameRoundStarted();
      await this._slotGame.getGameEventsEmitter().spinStarted();
      self.addRecoveryToQueue();
      self.triggerNextMessage();
      cbWhenPlatformReady();
      messageBus.postImmediate("common:GameCommitted");
    } else if (readyResponse.restoreMode === "SKIP") {
      self.restorePreviousWagers();
      self._latestEngineReponse = { wager: this._previousWagers.data[0] };

      if (self._latestEngineReponse.wager.bets.length) {
        let betData = self._latestEngineReponse.wager.bets[0].betdata;
        let stake = Number(betData.coin * 1000);
        gameData.recoveryStake = stake;

        if (betData.cmd === "LUCKYBET_BUY") {
          gameData.recoveryStake *= gameData.luckyBetUplift;
          gameData.goldenBetBtn.setRecovery();
        }
      }

      await self.handleSkipWin(self._latestEngineReponse);
      let win = await self.doCollectWinnings();
      gameData.winningsMeter.set(win);
      await self._slotGame.getGameEventsEmitter().gameRoundEnded();
      self._oldBalance = self._balance;
      self._preCommitBalance = self._balance;
      self.addBalanceEventToQueue();
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      self.triggerNextMessage();
      cbWhenPlatformReady();
    } else {
      // Show help page if this is BR license and we are not restoring a game
      let license = gameData.license;
      if (license === "" || license === undefined) {
        license = "default";
      } else {
        license = gameData.license.toUpperCase();
      }

      if (license === "BR") {
        gameData.helpPageScroll.open();
      }
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      cbWhenPlatformReady();
    }
  };

  // stop game interaction just in case the recovery popup will show (we dont know until we have a response from gameReady)
  messageBus.post("game:modal", {
    reason: "Waiting on Platform",
  });

  informGameReady(this._slotGame);
};

GatiServer.prototype.checkForAndHandlePrepaids = function (prepaidObj) {
  if (prepaidObj && prepaidObj.amount) {
    this.changeStake(prepaidObj.amount * 100);
    messageBus.post("prepaid:StakeChange", prepaidObj.amount * 100);
    messageBus.post("common:PromotionStarted");
    messageBus.post("platform:setButtonState", {
      buttonName: "Stake",
      enabled: false,
    });

    this._isPrePaidGame = true;
  } else if (this._isPrePaidGame) {
    this._isPrePaidGame = false;
    messageBus.post("common:PromotionEnded", {
      replayGame: this._inRewatchMode || this._inReplayMode,
    });
    messageBus.post("platform:setButtonState", {
      buttonName: "Stake",
      enabled: true,
    });
  }
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServerGame.prototype.getRandomForGui = function () {
  let rangeExplicit = 32768; // it is the default inside the mersenneTwister but in case they change it I am defining it here
  let r = MarsenneTwister.rand(rangeExplicit);
  let res = r / rangeExplicit;
  return res;
};

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    undefined,
    "LEFT_BOTTOM",
    ["playerState"]
  );
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController("stakeController");
    if (sc.isMaxStake() && !this._inReplayMode && !this._inRewatchMode && !this._isPrePaidGame && !isStakeLower) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;

  if (gameData.encoreEnabled) {
    newStake *= 1.5;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === "LUCKYBET_BUY"
  ) {
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  if (this._inReplayMode === true && this._slotGame.getWagerHelper().getPrepaidInfo().isPrepaid === true) {
    this.prepaidInitialBalance = parseFloat(loadData.wagers.data[0].bets[0].betdata.initialBalance) * 100;
    this.prepaidResultBalance = parseFloat(loadData.wagers.data[0].bets[0].eventdata.resultBalance) * 100;
  }

  this.addGameConfigToQueueBase(loadData);

  let message = this._messageQueue[0];
  message.buyBonusCost = 100;

  gdk.addConfigValue("AllowBuyBonus", message.slotConfig.gameModes["BONUS_BUY"] ? true : false);

  this.cheatPanelActive = loadData.customParameters.cheatPanel === "yes";

  let configMessage = this._messageQueue[this._messageQueue.length - 1];

  gameData.license = loadData.customParameters.license;

  if (configMessage.slotConfig.gameModes.BONUS_BUY_LOW) {
    this.freeSpinsCostMultiplierLow = configMessage.slotConfig.gameModes.BONUS_BUY_LOW.coinsPerBet / 10;
  }

  if (configMessage.slotConfig.gameModes.BONUS_BUY_MED) {
    this.freeSpinsCostMultiplierMed = configMessage.slotConfig.gameModes.BONUS_BUY_MED.coinsPerBet / 10;
  }

  if (configMessage.slotConfig.gameModes.BONUS_BUY_HIGH) {
    this.freeSpinsCostMultiplierHigh = configMessage.slotConfig.gameModes.BONUS_BUY_HIGH.coinsPerBet / 10;
  }

  configMessage.buyBonusCostFreeSpinsLow = this.freeSpinsCostMultiplierLow;
  configMessage.buyBonusCostFreeSpinsMed = this.freeSpinsCostMultiplierMed;
  configMessage.buyBonusCostFreeSpinsHigh = this.freeSpinsCostMultiplierHigh;

  gameData.recoveryStake = undefined;
  configMessage.slotConfig.coins = 10; // purely paytable
  configMessage.maxExposure = loadData.settings.slotConfig.MaxExposure;

  this.luckyBetCostMultiplier = configMessage.slotConfig.gameModes.LUCKYBET_BUY.coinsPerBet;

  configMessage.buyLuckyBet = this.luckyBetCostMultiplier;

  const { grand, major, minor, mini } = loadData.settings.slotConfig.Config["spinner:GameConfigEvent"].pots;
  configMessage.slotConfig.potMeters = { grand, major, minor, mini };

  if (configMessage.slotConfig.gameModes["BONUS_BUY"] || configMessage.slotConfig.gameModes["LUCKYBET_BUY"]) {
    allowBonusBuy = true;
  }

  if (
    loadData.customParameters.buyBonusDisabled === "yes" ||
    loadData.customParameters.buyBonusDisabled === "Yes" ||
    loadData.customParameters.license === "uk" ||
    loadData.customParameters.license === "fin" ||
    loadData.customParameters.license === "lt" ||
    loadData.customParameters.license === "nl" ||
    loadData.customParameters.license === "de"
  ) {
    allowBonusBuy = false;
  }

  let persistentState;

  if (this._inRewatchMode || this._inReplayMode || loadData.mode === "RESTORE") {
    let bets = loadData.wagers.data[0].bets;
    for (let i = 0; i < bets.length; ++i) {
      let bet = bets[i];
      //TODO check initial state?
      if (bet.eventdata && bet.eventdata.playerState) {
        persistentState = JSON.parse(bet.eventdata.playerState.state);
        break;
      }
    }
  } else if (loadData.settings.gameFeatures.playerState.playerState !== undefined) {
    persistentState = JSON.parse(loadData.settings.gameFeatures.playerState.playerState.state);
  } else {
    persistentState = loadData.settings.slotConfig.Config["spinner:GameConfigEvent"].defaultGameState;
  }

  this._persistentValues = persistentState;

  // let gcMessage = this._messageQueue[this._messageQueue.length - 1];
  configMessage.slotConfig.persistentValues = this._persistentValues;

  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);
    gameData.recoveryStake = stake;
    if (betData.cmd === "LUCKYBET_BUY") {
      gameData.recoveryStake *= 1.5;
    }
  }

  gdk.addConfigValue("AllowBuyBonus", allowBonusBuy ? true : false);
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (
      typeof bet.eventdata.response !== "undefined" &&
      Array.isArray(bet.eventdata.response.clientData.Parts) &&
      bet.eventdata.response.clientData.Parts.length > 0 &&
      typeof bet.eventdata.response.clientData.Parts[0].bonusBuyChestColour !== "undefined"
    ) {
      this.bonusBuyChestColour = bet.eventdata.response.clientData.Parts[0].bonusBuyChestColour;
    }
    switch (bet.betdata.cmd) {
      default:
        break;

      case "LUCKYBET_BUY":
        gameData.encoreEnabled = true;
        this._inLuckyBet = true;
        this._meta = {
          name: "lucky",
          value: true,
        };
        break;

      case "BONUS_BUY_LOW":
        this._inBuyABonus = true;
        this.buyBonusLowActive = true;
        this.buyBonusMedActive = false;
        this.buyBonusHighActive = false;
        this._meta = {
          name: "buyABonusLow",
          value: true,
          bonusBuyChestColour: this.bonusBuyChestColour,
        };
        break;

      case "BONUS_BUY_MED":
        this._inBuyABonus = true;
        this.buyBonusLowActive = false;
        this.buyBonusMedActive = true;
        this.buyBonusHighActive = false;
        this._meta = {
          name: "buyABonusMed",
          value: true,
          bonusBuyChestColour: this.bonusBuyChestColour,
        };
        break;

      case "BONUS_BUY_HIGH":
        this._inBuyABonus = true;
        this.buyBonusLowActive = false;
        this.buyBonusMedActive = false;
        this.buyBonusHighActive = true;
        this._meta = {
          name: "buyABonusHigh",
          value: true,
          bonusBuyChestColour: this.bonusBuyChestColour,
        };
        break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServer.prototype.addRecoveryToQueue = function () {
  let commandsSent = [];

  clientParams = this._previousWagers.data[0].bets[0].betdata.clientParams;

  for (let i = 0; i < this._previousWagers.data[0].bets.length; ++i) {
    if (this._previousWagers.data[0].bets[i].betdata) {
      commandsSent.push(this._previousWagers.data[0].bets[i].betdata.cmd);
    }
  }

  let lastEventData = this._previousWagers.data[0].bets[this._previousWagers.data[0].bets.length - 1].eventdata;
  if (lastEventData && lastEventData.nextCmds && lastEventData.nextCmds === "C") {
    this._didRecoveredGameSendFinish = true;
  } else {
    this._didRecoveredGameSendFinish = false;
  }

  messageBus.post("game:modal", {
    reason: "Recovery Popup",
    data: "Recovery Popup",
  });
  var message = {
    type: "common:RecoverGame",
    bpl: this._bpl,
    gameState: this._gameState,
    recoverFromStart: true,
    clientParams: clientParams,
    previousCommands: commandsSent,
  };
  if (this._meta) {
    message.metaData = this._meta.name;
    message.metaValue = this._meta.value;
    message.metaBonusBuyChestColour = this._meta.bonusBuyChestColour;
  }

  this._messageQueue.push(message);

  // this task gets held on to by features that need to recover player selection, they leave it when
  // they have finished inputting recovered selection. This way the Dead is only sent when everything has recovered
  // this is so we dont allow the sending of client state back to the engine if the new recovery didnt get as far through
  // as previous recovery.
  var message2 = {
    type: "common:RecoverGameListener",
    bpl: this._bpl,
    gameState: this._gameState,
    recoverFromStart: true,
    clientParams: clientParams,
    previousCommands: commandsSent,
  };
  if (this._meta) {
    message2.metaData = this._meta.name;
    message2.metaValue = this._meta.value;
  }

  this._gameNotFullyRecovered = true;

  // dont add it to the message queue as we dont want to block messages whilst this task is being hung on to
  messageBus.taskImmediate(message2.type, message2);
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this._inLuckyBet = stakeData.metaData.encore;

  this.buyBonusLowActive = stakeData.metaData.buyBonusLowActive || false;
  this.buyBonusMedActive = stakeData.metaData.buyBonusMedActive || false;
  this.buyBonusHighActive = stakeData.metaData.buyBonusHighActive || false;

  if (this._forces === undefined || !this._forces) {
    this._forces = "";
    this.addCheatToRequest(stakeData, this._forces);
  }

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController("stakeController");
  let baseStake = stakeController.getBaseStake("default") / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._forces === "" && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
  }

  request.clientParams = JSON.stringify({ GambleMode: { mode: gameController.gambleModeIndex } });

  if (this._inLuckyBet) {
    this._coinValue = 10;
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue;
    request.coins = this.luckyBetCostMultiplier;
    request.cmd = "LUCKYBET_BUY";
  } else if (this._inBuyABonus) {
    if (this.buyBonusMedActive) {
      baseStake = stakeController.getBaseStake("BONUS_BUY_MED") / 100;
      request.amount = baseStake * this.freeSpinsCostMultiplierMed;
      request.coin = baseStake / this._coinValue;
      this.currentMode = "BonusBuyMedium";
      request.cmd = "BONUS_BUY_MED";
    } else if (this.buyBonusHighActive) {
      baseStake = stakeController.getBaseStake("BONUS_BUY_HIGH") / 100;
      request.amount = baseStake * this.freeSpinsCostMultiplierHigh;
      request.coin = baseStake / this._coinValue;
      this.currentMode = "BonusBuyHigh";
      request.cmd = "BONUS_BUY_HIGH";
    } else {
      baseStake = stakeController.getBaseStake("BONUS_BUY_LOW") / 100;
      request.amount = baseStake * this.freeSpinsCostMultiplierLow;
      request.coin = baseStake / this._coinValue;
      this.currentMode = "BonusBuyLow";
      request.cmd = "BONUS_BUY_LOW";
    }
  }
};

GatiServerGame.prototype.addFSStartToQueue = function () {
  this.totalFsWinnings = 0;
  var message = {};

  message.type = "spinner:FreeSpinsStartEvent";
  //add fs info
  message.bonusWin = 0;
  message.baseGameChestClose = this.baseGameChestClose;
  message.bonusBuyChestColour = this.bonusBuyChestColour;
  message.devilLevel = this.devilLevel;
  message.isBonusBuy = this.isBonusBuy;
  message.freeSpins = this.freeSpins;
  message.startFreeSpinsAmt = this.freeSpins[0].spinsRemaining + 1 - this.freeSpins[0].spinsAdded;

  this.inGamble = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  let message = {};
  message.type = "spinner:FreeSpinsDataEvent";
  message.num = this.fsCount + 1;
  message.fsSpinWinnings = this.fsSpinWinnings;
  message.totalFsWinnings = this.totalFsWinnings;
  message.spinsRemaining = this.spinsRemaining;
  message.spinsAdded = this.spinsAdded;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (winnings, isCapped) {
  let message = {};
  message.type = "spinner:FreeSpinsEndEvent";
  message.fsWinnings = winnings;
  message.totalWinnings = this._totalWinnings;
  message.isBigWin = false;
  message.isCapped = isCapped;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.shuffleArray = function (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
};

GatiServerGame.prototype.getSpinData = function (cb, data, playerState, initialPlayerState) {
  const parts = data.Parts;
  const isRespin = parts[0].respinModifier?.isAwarded;

  if (isRespin) {
    parts[0].payLines.totalLineWinnings = parts[0].payLines.winningLines.reduce((acc, curr) => {
      return acc + curr.winAmount;
    }, 0);
  }

  console.log("%c YGGDRASIL SERVER GAME DATA", "color: red", data);
  // set the initial player state (only do for forces?)
  if (!this.inFS) {
    gameController.setInitialSpinData(initialPlayerState);
  }

  this._forces = "";

  if (this.inFS) {
    if (this._inBuyABonus) {
      this.getSpinDataFS(parts[0], cb);
    } else {
      this.getSpinDataFS(parts[1], cb);
    }
    return;
  } else {
    this.updatePersistentState(initialPlayerState, playerState, this.currentMode);
  }

  let totalWon = 0;

  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    this._localRngSeed = -1;
    this._uiRandomSeed = data.UIRandomSeed;
    if (type === "baseGame") {
      this._finalBaseWinnings = parts[0].winAmount;
      this._localRngSeed = data.ResultId;

      totalWon += this.getSpinDataNormal(parts[i]);

      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }
      let gcMessage = this._messageQueue[this._messageQueue.length - 1];
      gcMessage.persistentValues = this._persistentValues;
    } else if (type === "freeSpins") {
      this.inGamble = false;
      this.inFS = true;
      this.fsCount = 0;
      this.freeSpins = parts[i].spins;
      this._finalFsWinnings = parts[i].winAmount;

      //add fs info
      this.baseGameChestClose = parts[i].baseGameChestClose;
      this.bonusBuyChestColour = parts[i].bonusBuyChestColour;
      this.devilLevel = parts[i].devilLevel;
      this.isBonusBuy = parts[i].isBonusBuy;

      if (this.isBonusBuy) {
        this._finalBaseWinnings = 0;
      }
      this._totalWinnings = this._finalBaseWinnings + this._finalFsWinnings;

      this.addFSStartToQueue();
    }
  }

  if (cb != undefined) {
    cb();
  }
  this.triggerNextMessage();
};

GatiServerGame.prototype.updatePersistentState = function (initState, playerState, mode) {
  let gameModeStrings = ["Basic", "LuckyBet", "BonusBuyLow", "BonusBuyMedium", "BonusBuyHigh"];

  if (initState !== undefined) {
    let initialState = JSON.parse(initState.state);
    this._persistentValues.devilLevel = initialState.devilLevel;
    this._persistentValues.leftChestColour = initialState.leftChestColour;
    this._persistentValues.leftChestSize = initialState.leftChestSize;
    this._persistentValues.nextDevilCount = initialState.nextDevilCount;
    this._persistentValues.rightChestColour = initialState.rightChestColour;
    this._persistentValues.rightChestSize = initialState.rightChestSize;
    this._persistentValues.version = initialState.version;
  }
  if (playerState !== undefined) {
    let newState = JSON.parse(playerState.state);
    this._persistentValues.devilLevel = newState.devilLevel;
    this._persistentValues.leftChestColour = newState.leftChestColour;
    this._persistentValues.leftChestSize = newState.leftChestSize;
    this._persistentValues.nextDevilCount = newState.nextDevilCount;
    this._persistentValues.rightChestColour = newState.rightChestColour;
    this._persistentValues.rightChestSize = newState.rightChestSize;
    this._persistentValues.version = newState.version;
  }
};

GatiServerGame.prototype.processModifiers = function (data, spinEvent) {};

GatiServerGame.prototype.addModifiersToQueue = function (data, cloneReal) {};

GatiServerGame.prototype.hasModifier = function (data) {};

GatiServerGame.prototype.addWinnings = function (winningLinesData) {
  this.addWinningsToQueue(winningLinesData);
};

GatiServerGame.prototype.addSpinDataToQueue = function (event) {
  var message = {};
  message.type = "spinner:SpinEvent";

  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.resultPanel = {};
  message.resultPanel.reels = 5;
  message.resultPanel.reelList = event.reelList;
  message.isPrePaidGame = this._isPrePaidGame;
  message.awardPayLinesBeforeCollectables = this.awardPayLinesBeforeCollectables;
  message.hasPaylines = this.hasPaylines;
  message.spinToCollectables = this.spinToCollectables;
  message.nudgeModifier = this.nudgeModifier;
  message.boostModifier = this.boostModifier;
  message.multiModifier = this.multiModifier;
  message.respinModifier = this.respinModifier;
  message.collectableAwards = this.collectableAwards;
  message.treasureChestAdd = this.treasureChestAdd;
  message.treasureChestClose = this.treasureChestClose;
  message.devilProgress = this.devilProgress;
  message.canFirewave = this.canFirewave;
  message.finalFreeSpin = this.finalFreeSpin;
  message.firstFreeSpin = this.firstFreeSpin;
  message.bonusBuyChestAdd = this.bonusBuyChestAdd;
  // message.resultPanel.symbolsAbove = event.symbolsAbove;
  // message.resultPanel.symbolsBelow = event.symbolsBelow;

  if (this._localRngSeed !== -1) {
    message.localRng = this._localRngSeed;
  }

  if (this._uiRandomSeed !== -1) {
    message.uiRandomSeed = this._uiRandomSeed;
  }

  this._messageQueue.push(message);
  return message;
};

GatiServerGame.prototype.getSpinDataGeneric = function (spinEvent, data, freeSpinsActive, cb) {
  let isCapped = data.winCapped;
  this.finalFreeSpin = false;
  this.firstFreeSpin = false;

  if (freeSpinsActive) {
    if (this.freeSpins.length === this.fsCount) {
      this.finalFreeSpin = true;
    }
    if (this.fsCount === 1) {
      this.firstFreeSpin = true;
    }
  }

  const inFS = gameController.boughtBonus || gameController.inFreeSpins;

  let stake = inFS ? gameController.getCurrentModeStake() : gameController.globalHelperGetBaseStake();
  let winningLinesEvent = { paylines: data.payLines, collectableAwards: data.collectableAwards };

  //Game Specific Info

  this.awardPayLinesBeforeCollectables = data.awardPayLinesBeforeCollectables;
  this.hasPaylines = data.payLines.winningLines.length > 0;
  this.spinToCollectables = data.spinToCollectables;
  this.nudgeModifier = data.nudgeModifier;
  this.boostModifier = data.boostModifier;
  this.multiModifier = data.multiModifier;
  this.respinModifier = data.respinModifier;
  this.collectableAwards = data.collectableAwards;
  this.treasureChestAdd = data.treasureChestAdd;
  this.treasureChestClose = data.treasureChestClose;
  this.devilProgress = data.devilProgress;
  this.bonusBuyChestAdd = data.bonusBuyChestAdd;

  // Checking if the first symbol value is even as a repeatable way to get a 50/50 chance.
  const isFirstSymbolValueEven = spinEvent.reelList[0].symbols[0].value % 2 === 0;

  // check firewave conditions
  const stakeTimes10 = stake * 10;
  const numberCollectables = data.collectableAwards.awards.length;

  this.canFirewave = isFirstSymbolValueEven && data.winAmount >= stakeTimes10 && numberCollectables >= 3;

  //Change coin symbols
  if (this.spinToCollectables.length > 0) {
    for (let i = 0; i < this.spinToCollectables.length; i++) {
      if (this.spinToCollectables[i].type === "Cash") {
        const coin = this.spinToCollectables[i];
        const baseVal = coin.amount;
        const value = baseVal / stake;
        const reel = coin.coord.reel;
        const row = coin.coord.row;
        this.getNewCoins(value, spinEvent, reel, row);
      }
    }
  }

  this.addSpinDataToQueue(spinEvent);

  if (winningLinesEvent.paylines.winningLines.length > 0 || winningLinesEvent.collectableAwards.awards.length > 0) {
    this.addWinnings(winningLinesEvent);
    //todo keep this for potential wincap
    // const message = this._messageQueue[this._messageQueue.length - 1];
    // message.isCapped = isCapped;
  }

  if (data.respinModifier.isAwarded) {
    this.addRespinDataToQueue(data.respinModifier);
    this.addPostRespinWinningsToQueue({ totalWinnings: data.winAmount });
  }

  if (freeSpinsActive) {
    this.fsWinnings += data.winAmount;

    this.fsSpinWinnings = data.winAmount;
    this.totalFsWinnings = data.winAmountSoFar;
    this.treasureChestClose = data.treasureChestClose;
    this.spinsAdded = data.spinsAdded;
    this.spinsRemaining = data.spinsRemaining;
    this.respinsAdded = data.spinsAdded;

    if (this.fsCount < this.freeSpins.length) {
      this.addFSDataToQueue();
    } else {
      this.addFSEndToQueue(this.fsWinnings, data, isCapped);
      this.addGameCompleteToQueue(this.fsWinnings);
      this.inFS = false;
    }

    if (this.respinsAdded !== 0 && !isCapped) {
      this.addRetriggerToQueue(this.respinsAdded);
    }

    cb();
    this.triggerNextMessage();
  } else {
    return data.winAmount;
  }
};

GatiServerGame.prototype.getNewCoins = function (value, event, reel, row) {
  let newSym;

  switch (value) {
    case 0.5:
      newSym = 5;
      break;

    case 1:
      newSym = 22;
      break;

    case 1.5:
      newSym = 6;
      break;

    case 2:
      newSym = 23;
      break;

    case 2.5:
      newSym = 7;
      break;
  }

  event.reelList[reel].symbols[row].value = newSym;
};

GatiServerGame.prototype.getSpinDataNormal = function (data) {
  let spinEvent = data.stopWindow;
  let winningLinesEvent = data.payLines;

  if (!this.validateResponse(spinEvent)) return;
  if (!this.validateResponse(winningLinesEvent)) return;

  return this.getSpinDataGeneric(spinEvent, data, false, function () {});
};

GatiServerGame.prototype.getSpinDataFS = function (data, cb) {
  let thisFsOutcome = data.spins[this.fsCount++];
  let spinEvent = thisFsOutcome.stopWindow;

  this.getSpinDataGeneric(spinEvent, thisFsOutcome, true, cb);
};

GatiServer.prototype.endGame = async function (cb) {
  this._endGame = true;
  await this.doEndGame(cb);
  this._endGame = false;
};

GatiServerGame.prototype.sendGambleResponseToServer = function (response, cb) {
  if (this._gameNotFullyRecovered) {
    // no need to send state, already done and part of recovery
    this.moveToNextBetData();
    messageBus.postImmediate("Gamble:HandledCommand");
    timerManager.addTimer(500, undefined, cb);
    return;
  }

  this.resetCurrentBetData();

  let self = this;

  let nextStep = this._latestEngineReponse.wager.bets[this._latestEngineReponse.wager.bets.length - 1].step + 1;

  let playData = {
    cmd: response,
    step: nextStep,
    clientParams: "",
  };

  // TODO CM - Get This Working
  // if (this._forces) {
  //   this.addCheatToRequest(playData, this._forces, 1);
  // }

  const sendCommand = async () => {
    self._latestEngineReponse = await self._slotGame.play(playData);
    self._forces = self.updateForces(self._forces);
    cb();
  };

  sendCommand().then(() => {
    messageBus.postImmediate("spinner:GambleCommandSent");
  });
};

GatiServerGame.prototype.addRespinDataToQueue = function (data) {
  var message = {};

  message.type = "spinner:RespinDataEvent";

  message.respinData = data;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addPostRespinWinningsToQueue = function (data) {
  var message = {};

  message.type = "spinner:PostRespinWinningsEvent";

  message.postRespinData = data;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addGambleDataToQueue = function (data) {
  var message = {};

  message.type = "spinner:GambleDataEvent";

  message.isCapped = data.winCapped;
  message.bonusGambleOptions = data.bonusGambleOptions;
  message.cashGambleOptions = data.cashGambleOptions;
  message.collectionOptions = data.collectionOptions;

  let self = this;
  message.resultCallback = function (obj, cb) {
    self.sendGambleResponseToServer(obj.response, cb);
  };
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSAwardToQueue = function (freespinsAwarded) {
  var message = {};
  message.type = "spinner:FreeSpinsAwardEvent";
  message.freeSpinsAwarded = freespinsAwarded;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addRetriggerToQueue = function (count) {
  let message = {};
  message.type = "spinner:FreeSpinsRetriggerEvent";
  message.num = count;
  message.trailLevel = this._trailLevel;
  this._messageQueue.push(message);
};

GatiServer.prototype.getCheatString = function () {
  return this.force;
};

GatiServer.prototype.logCheatString = function () {
  this.force = this._latestEngineReponse.wager.bets[0].eventdata.response.clientData.Repro;

  if (this.force !== "") {
    console.log("force: " + this.force);
  }
};

GatiServer.prototype.requestNextSpinOutcome = function (cb) {
  this.logCheatString();
  let outcome = this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.response.clientData;
  let playerState = this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.playerState;
  let initialPlayerState = {
    state: JSON.stringify(
      this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.response.clientData.InitialGameState
    ),
  };
  this.getSpinData(cb, outcome, playerState, initialPlayerState);
};

GatiServer.prototype.addCheatToRequest = function (request, forces, index = 0) {
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  // let nextCheatStr = JSON.stringify(forcesJson[index]);
  request.cheat = forces;
};

GatiServer.prototype.updateForces = function (forces) {
  return undefined;
};
